module.exports = __webpack_public_path__ + "static/img/yg_btn1.f6110c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/yg_btn1.png
// module id = jGsv
// module chunks = 7